import { Calendar, CheckSquare, CircleDot, DollarSign, Hash, Link, List, Mail, Palette, Phone, SlidersHorizontal, ToggleLeft, Type, Upload, type LucideIcon } from 'lucide-react'
import { AlignLeft, MailOpen, CalendarClock, Clock, CornerDownLeft, Heading, Minus, MousePointerClick, Percent, Pilcrow, SeparatorHorizontal, Star } from 'lucide-react'

import { FormFieldType } from '@/types/enums'

import { FIELD_TYPE_COLORS } from './fieldTypeColors'

export interface FieldTypeConfig {
  type: FormFieldType
  label: string
  icon: LucideIcon
  bg: string
  iconColor: string
  border: string
  badge: string
  accentBar: string
}

const FIELD_TYPE_DETAILS: Record<FormFieldType, { label: string; icon: LucideIcon }> = {
  [FormFieldType.TEXT]: { label: 'Text', icon: Type },
  [FormFieldType.EMAIL]: { label: 'Email', icon: Mail },
  [FormFieldType.NUMBER]: { label: 'Number', icon: Hash },
  [FormFieldType.CURRENCY]: { label: 'Currency', icon: DollarSign },
  [FormFieldType.DATE]: { label: 'Date', icon: Calendar },
  [FormFieldType.SELECT]: { label: 'Select', icon: List },
  [FormFieldType.RADIO]: { label: 'Radio', icon: CircleDot },
  [FormFieldType.CHECKBOX]: { label: 'Checkboxes', icon: CheckSquare },
  [FormFieldType.RANGE]: { label: 'Range', icon: SlidersHorizontal },
  [FormFieldType.COLOR]: { label: 'Color', icon: Palette },
  [FormFieldType.URL]: { label: 'URL', icon: Link },
  [FormFieldType.TOGGLE]: { label: 'Toggle', icon: ToggleLeft },
  [FormFieldType.PHONE]: { label: 'Phone', icon: Phone },
  [FormFieldType.FILE_UPLOAD]: { label: 'File Upload', icon: Upload },
  [FormFieldType.BUTTON]: { label: 'Button', icon: MousePointerClick },
  [FormFieldType.PARAGRAPH]: { label: 'Paragraph', icon: AlignLeft },
  [FormFieldType.DATETIME]: { label: 'Date & Time', icon: CalendarClock },
  [FormFieldType.TIME]: { label: 'Time', icon: Clock },
  [FormFieldType.RATING]: { label: 'Rating', icon: Star },
  [FormFieldType.PERCENT]: { label: 'Percent', icon: Percent },
  [FormFieldType.SECTION_HEADING]: { label: 'Section heading', icon: Heading },
  [FormFieldType.STATIC_TEXT]: { label: 'Static text', icon: Pilcrow },
  [FormFieldType.DIVIDER]: { label: 'Divider', icon: Minus },
  [FormFieldType.LINE_BREAK]: { label: 'Line break', icon: CornerDownLeft },
  [FormFieldType.PAGE_BREAK]: { label: 'Page break', icon: SeparatorHorizontal },
  [FormFieldType.EMAIL_MESSAGE]: { label: 'Linked email', icon: MailOpen },
}

export const FIELD_CONFIG: Record<FormFieldType, FieldTypeConfig> = Object.fromEntries(
  Object.entries(FIELD_TYPE_DETAILS).map(([rawType, detail]) => {
    const type = rawType as FormFieldType
    return [type, { type, ...detail, ...FIELD_TYPE_COLORS[type] }]
  })
) as Record<FormFieldType, FieldTypeConfig>

export const PALETTE_ITEMS = Object.values(FIELD_CONFIG)

